import "knockout";
import $ from "jquery";
import config from "flow/config";
import register from "flow/knockout/register";

const styles = [
    { type: config.notificationTypes.error, style: "error", icon: "lc-icon-Cancel-large" },
    { type: config.notificationTypes.warning, style: "warning", icon: "lc-icon-Alert" },
    { type: config.notificationTypes.success, style: "positive", icon: "lc-icon-Check-mark" },
    { type: config.notificationTypes.info, style: "information", icon: "lc-icon-Info" }
];

register.registerKnockoutBinding("notificationLocal", {
    init: function (element, valueAccessor) {
        // This will be called when the binding is first applied to an element
        // Set up any initial state, event handlers, etc. here

        handleNotification(element, valueAccessor);
    },
    update: function (element, valueAccessor) {
        // This will be called once when the binding is first applied to an element,
        // and again whenever the associated observable changes value.
        // Update the DOM element based on the supplied values here.

        handleNotification(element, valueAccessor);
    }
});

function handleNotification(element: HTMLElement, valueAccessor: () => any) {
    const notificationText = valueAccessor().text();

    const notification = $(element);
    const component = notification.next();

    if (notificationText !== undefined) {
        const notificationType = valueAccessor().type();
        const notificationOpaque = valueAccessor().opaque();

        handleStyle(notification, notificationType);
        handleText(notification, notificationText);

        if (notificationOpaque !== true) {
            if (component.hasClass("ui-dialog-content")) {
                component.css("padding-top", parseInt(notification.css("height"), 10) + 7 + "px");
            } else if (component.hasClass("lc-menu__in-menu") === true) {
                component.css("padding-top", parseInt(notification.css("height"), 10) + 12 + "px");
            } else {
                window.requestAnimationFrame(function () {
                    component.css(
                        "padding-top",
                        parseInt(notification.css("top"), 10) + parseInt(notification.css("height"), 10) + 14 + "px"
                    );
                });
            }

            notification.removeClass("notificationLocal-opaque");
        } else {
            notification.addClass("notificationLocal-opaque");
            component.css("padding-top", "");
        }

        notification.show();
    } else {
        component.css("padding-top", "");
        notification.removeClass("notificationLocal-opaque");

        notification.hide();
    }
}

function handleStyle(notification: JQuery<HTMLElement>, newType: number) {
    let newStyle = "";
    let newIcon = "";
    const lcNotificationImage = notification.find(".lc-notification-image > span");

    for (let i = 0; i < styles.length; i++) {
        if (newType !== styles[i].type) {
            notification.removeClass(styles[i].style);
            lcNotificationImage.removeClass(styles[i].icon);
        } else {
            newStyle = styles[i].style;
            newIcon = styles[i].icon;
        }
    }

    notification.addClass(newStyle);
    lcNotificationImage.addClass(newIcon);
}

function handleText(notification: JQuery<HTMLElement>, notificationText: string) {
    const lcNotificationText = notification.find(".lc-notification-text > span");

    lcNotificationText.empty();
    lcNotificationText.append(notificationText);
}
